  import ImageData from './Image';

  /* eslint-disable camelcase */
  class CareersData {
    constructor({
      attributes: {
        SEO_meta_tags,
        benefits_and_polices,
        explore_opportunities_link,
        explore_opportunities_text,
        key_team_slider,
        portrait_of_an_educator,
        hero,
        media_with_title,
        eduaction_culture
      }
    }) {
      this.heroData = {
        title1: hero?.text_line1,
        title2: hero?.text_line2,
        title3: hero?.text_line3,
        actionText: hero?.button_text,
        actionLink: hero?.button_link,
        image: new ImageData(hero?.background_image?.data)
      };

      this.media_with_title = {
        title1: media_with_title?.text_line1,
        title2: media_with_title?.text_line2,
        videoLink: media_with_title?.video_link,
        media: new ImageData(media_with_title?.media?.data)
      };

      this.eduaction_culture = {
        text1_line1: eduaction_culture?.text1_line1,
        text1_line2: eduaction_culture?.text1_line2,
        text2_line1: eduaction_culture?.text2_line1,
        text2_line2: eduaction_culture?.text2_line2,
        description_1: eduaction_culture?.description_1,
        description_2: eduaction_culture?.description_2,
        image1: new ImageData(eduaction_culture?.image1?.data),
        image2: new ImageData(eduaction_culture?.image2?.data),
      };

      this.explore = {
        text: explore_opportunities_text,
        link: explore_opportunities_link
      };

      const items = benefits_and_polices.map((item) => {
        const { id, image, title, description } = item;

        return {
          id,
          title,
          image: new ImageData(image?.data),
          text: description
        };
      });
      this.benefits = items;

      const keyTeamItems = key_team_slider.map((teamItem) => {
        const { id, title, description, image, slide_link_text, slide_link_url } = teamItem;

        return {
          id,
          title,
          text: description,
          linkText: slide_link_text,
          linkUrl: slide_link_url,
          image: new ImageData(image.data)
        };
      });
      this.keyTeam = keyTeamItems;

      this.portraitOfEducator = new ImageData(portrait_of_an_educator?.data);

      this.metaTags = SEO_meta_tags?.map(
        ({ id, meta_tag_name: name, meta_tag_content: content }) => ({
          id,
          name,
          content
        })
      );
    }
  }

  export default CareersData;
